import { render, staticRenderFns } from "./TransactionsModal.vue?vue&type=template&id=21cec1bf&scoped=true&"
import script from "./TransactionsModal.vue?vue&type=script&lang=js&"
export * from "./TransactionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cec1bf",
  null
  
)

export default component.exports